// Module
var code = "<div class=\"level-left\" id=\":selectGroupElementId\"> <div class=\"level-item\"> <label class=\"label\"> :selectLabel </label> </div> <div class=\"level-item selector\" id=\":selectContainerId\"></div> </div> ";
// Exports
export default code;